var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ip-server-container"},[_c('IPServerManager',{attrs:{"companyUID":_vm.companyUID}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }